import { isCatalogModeCountry } from '@/lib/const';
import { getCountryFromLocale } from '@/lib/i18n';
import { normalizeCtaType, resolveNotifyMeForBrand, type CtaType } from './cta';

/**
 * Whether the URL locale maps to a catalog browsing country (no listing e-commerce).
 *
 * @deprecated Catalog mode is now resolved from config-driven e-commerce
 * readiness. Prefer `resolveEcommerceReady` (server) or `useEcommerceReady`
 * (client) and invert `ready`. Retained only for the static locale-string
 * check; no runtime callers remain.
 *
 * Example Input:
 * locale="ie-en"
 *
 * Example Output:
 * true
 */
export function isCatalogModeLocale(locale: string): boolean {
  const countryCode = getCountryFromLocale(locale).toUpperCase();
  return isCatalogModeCountry(countryCode);
}

/**
 * Listing-card CTA in catalog browsing markets.
 * Mirrors Breitling WatchCard productCatalogMode override.
 *
 * Example Input:
 * ctaType="PRE_ORDER", isCatalogMode=true
 *
 * Example Output:
 * "DISCOVER"
 */
export function getEffectiveListingCta(
  ctaType: string | undefined | null,
  isCatalogMode: boolean
): CtaType {
  if (isCatalogMode) return 'DISCOVER';
  return resolveNotifyMeForBrand(normalizeCtaType(ctaType));
}
